var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "self-defined-classname",
    attrs: { id: "self_defined_element" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }